export default "__VITE_ASSET__B4s4$JQw__"